import React, { useState } from "react";
import "./App.css";
import Layout from "./Layout/Layout";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "./store/Reduxstore";
import { Loader } from "./const/Spinner";
import Wrapper from "./Layout/Wrapper";
import PrivateRoute from "./Component/PrivateRoute";
import Login from "./pages/Loginpage";
import AssetInventory from "./pages/AssetInventory";
import ResoursePlanner from "./pages/ResoursePlanner";
import CreateFault from "./pages/Masters/CreateFault";
import SearchFault from "./pages/Masters/SearchFault";
import ServicesForm from "./pages/Masters/ServicesForm";
import Services from "./pages/Masters/Services";
import FaultAssetMapping from "./pages/Masters/FaultAssetMapping";
import TemplateServiceColumn from "./pages/Masters/TemplateServiceColumn";
import InspectionMain from "./pages/Masters/InspectionMain";
import InspectionForm from "./pages/Masters/InspectionForm";
import Inspection from "./pages/Masters/Inspection";
import InspectionAssetMapping from "./pages/Masters/InspectionAssetMapping";
import InspectionColumn from "./pages/Masters/TemplateInspectionColumn";
import Notice from "./pages/Notice";
import Latest from "./pages/Latest";
import IndentsMain from "./pages/IndentsMain";
import StockCodee from "./pages/Masters/StockCodee";
import StockDatabase from "./pages/Masters/StockDatabase";
import StockInOut from "./pages/Masters/StockInOut";
import UnderDevelopment from "./pages/UnderDevelopment";
import FileManagerComponentIndex from "./pages/FileManager/FileManagerComponent";
import IndentInventory from "./pages/Indent/IndentInventory";
import AssetOwner from "./pages/Masters/AssetOwner";
import AssetCategory from "./pages/Masters/Category";
import ClassCode from "./pages/Masters/ClassCode";
import CostAllocation from "./pages/Masters/CostAllocation";
import AssetCountry from "./pages/Masters/Country";
import FamilyAsset from "./pages/Masters/FamilyAsset";
import AssetCurrency from "./pages/Masters/InsuranceCurrency";
import LocalStore from "./pages/Masters/LocalStore";
import MastersMain from "./pages/Masters/MastersMain";
import Model from "./pages/Masters/Model";
import Project from "./pages/Masters/Project";
import Region from "./pages/Masters/Region";
import Status from "./pages/Masters/Status";
import StockCode from "./pages/Masters/StockCode";
import Supplier from "./pages/Masters/Supplier";
import AssetTechnique from "./pages/Masters/Technique";
import Transport from "./pages/Masters/Transport";
import Transporter from "./pages/Masters/Transporter";
import UserHistory from "./pages/Masters/UserHistory";
import Users from "./pages/Masters/Users";
import AssetManufacturer from "./pages/Masters/Manufacturer";
import StockTransfer from "./pages/Masters/StockTransfer";
import ServiceType from "./pages/Masters/ServiceType";
import InspectionType from "./pages/Masters/InspectionType";
import IndentsTemplate from "./pages/IndentsTemplate";

import Timesheets from "./pages/Indent/Timesheet";
import ViewTimesheet from "./pages/Indent/ViewTimesheet";
import ResetPass from "./pages/ResetPassword";
import Backcharge from "./pages/Masters/Backcharge";


const App: React.FC = () => {
  const loading = useSelector((state: RootState) => state.common.data.loading);
  console.log(window.location.pathname)
  const [, setPathname] = useState("");
  // const navigateTo = useNavigate();
  // const { router, setPathname } = useDemoRouter(getDefaultPath(userDetails?.role.map((role) => role.roleName)));


  return (
    <>
      {loading && <Loader />}
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ResetPass />} />
          <Route path="/erp" element={<Wrapper />}>
            <Route
              path="pages" element={<PrivateRoute>
                <Layout />
              </PrivateRoute>
              }
            >

              <Route path="assetInventory" element={<AssetInventory />} />
              <Route path="maintenance/report-fault" element={<CreateFault />} />
              <Route path="maintenance/fault-database" element={<SearchFault setPathname={setPathname} />} />
              <Route path="services/new-service" element={<ServicesForm />} />
              <Route path="services/service-type" element={<ServiceType />} />
              <Route path="services/service-template" element={<Services />} />
              <Route path="services/service-mapping" element={<FaultAssetMapping />} />
              <Route path="services/service-template-column" element={<TemplateServiceColumn />} />
              <Route path="inspection" element={<InspectionMain inspectionType="yourInspectionType" setPathname={setPathname} />} />
              <Route path="inspection/new-inspection" element={<InspectionForm />} />
              <Route path="inspection/inspection-template" element={<Inspection />} />
              <Route path="inspection/inspection-mapping" element={<InspectionAssetMapping />} />
              <Route path="inspection/inspection-template-column" element={<InspectionColumn />} />
              <Route path="inspection/inspection-type" element={<InspectionType />} />
              <Route path="broadcast/broadcast_input" element={<Notice />} />
              <Route path="broadcast/broadcast" element={<Latest />} />
              <Route path="stores/main-database" element={<StockDatabase />} />
              <Route path="stores/stock-in-out" element={<StockInOut />} />
              <Route path="stores/country-view" element={<StockCodee />} />
              <Route path="stores/stock-transactions" element={<StockTransfer />} />
              <Route path="indentsInventory" element={<IndentsMain setPathname={setPathname} />} />
              <Route path="indentsTemplate" element={<IndentsTemplate setPathname={setPathname} />} />
              <Route path="reporting" element={<UnderDevelopment />} />
              {/* <Route path="timeSheets/view-timesheets" element={<UnderDevelopment  />} /> */}
              <Route path="timeSheets/view-timesheets" element={<Timesheets />} />
              <Route path="timeSheets/timesheet-backcharge" element={<ViewTimesheet />} />

              <Route path="timeSheets/sync-with-tips" element={<UnderDevelopment />} />
              <Route path="timeSheets/back-charge" element={<Backcharge />} />
              <Route path="timeSheets/invoicing-conditions" element={<UnderDevelopment />} />
              <Route path="masters" element={<MastersMain masterType="masters" setPathname={setPathname} />} />
              <Route path="indents" element={<IndentInventory />} />
              <Route path="userhistory" element={<UserHistory />} />
              <Route path="fileManager" element={<FileManagerComponentIndex />} />
              <Route path="masters/masters-list/user" element={<Users />} />
              <Route path="masters/assets/family_asset" element={<FamilyAsset />} />
              <Route path="masters/assets/asset_owner" element={<AssetOwner />} />
              <Route path="masters/assets/model" element={<Model />} />
              <Route path="masters/assets/class_code" element={<ClassCode />} />
              <Route path="masters/masters-list/technique" element={<AssetTechnique />} />
              <Route path="masters/masters-list/currency" element={<AssetCurrency />} />
              <Route path="masters/masters-list/category" element={<AssetCategory />} />
              <Route path="masters/masters-list/country" element={<AssetCountry />} />
              <Route path="masters/masters-list/project" element={<Project />} />
              <Route path="masters/masters-list/region" element={<Region />} />
              <Route path="masters/assets/manufacturer" element={<AssetManufacturer />} />
              <Route path="masters/stores/stock_code" element={<StockCode />} />
              <Route path="masters/stores/localstore" element={<LocalStore />} />
              <Route path="logistics/status_logistics" element={<Status />} />
              <Route path="logistics/cost_allocation" element={<CostAllocation />} />
              <Route path="logistics/transport_type" element={<Transport />} />
              <Route path="logistics/transporter" element={<Transporter />} />
              <Route path="logistics/supplier" element={<Supplier />} />
              <Route path="planner" element={<ResoursePlanner />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </>
  );
};

export default App;
